import { getLocationAttachment } from 'conversations-message-history/attachments/operators/locationAttachmentGetters';
import { getContactAttachments } from 'conversations-message-history/attachments/operators/contactAttachmentGetters';
import { getUnsupportedContentAttachment } from 'conversations-message-history/attachments/operators/unsupportedContentAttachmentGetters';
import { getContentAttachments, getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { List as ImmutableList } from 'immutable';
import { isEmailCMF
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getFilteredAttachments
// @ts-expect-error module not typed
} from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
import AttachmentsFooter from '../attachments/AttachmentsFooter';
import { jsx as _jsx } from "react/jsx-runtime";
const CommonMessageAttachmentsFooter = ({
  message,
  fileAttachments
}) => {
  const locationMetadata = getLocationAttachment(message);
  const contactsMetadata = getContactAttachments(message);
  const unsupportedContent = getUnsupportedContentAttachment(message);

  //remove header attachment from rest of the file attachments
  const contentAttachments = fileAttachments && fileAttachments.size ? getContentAttachments(message, fileAttachments) : ImmutableList();
  const attachments = isEmailCMF(message) ? fileAttachments : getFilteredAttachments({
    fileAttachments: contentAttachments,
    canRender: false
  });
  const genericChannelId = getGenericChannelId(message);
  const shouldRenderAttachments = Boolean(locationMetadata) || Boolean(contactsMetadata) || Boolean(unsupportedContent) || attachments && attachments.size > 0;
  if (!shouldRenderAttachments) return null;
  return /*#__PURE__*/_jsx(AttachmentsFooter, {
    fileAttachments: attachments,
    locationMetadata: locationMetadata || undefined,
    contactsMetadata: contactsMetadata || undefined,
    unsupportedContent: unsupportedContent || undefined,
    genericChannelId: genericChannelId
  });
};
CommonMessageAttachmentsFooter.displayName = 'CommonMessageAttachmentsFooter';
export default CommonMessageAttachmentsFooter;